export class TimePicker {
  locationId: number;
  startTimeUtc: string;
  startTime: string;
  endTimeUtc: string;
  displayTimeRange: string;
  isSelectable: boolean;
  pickupType: number | null;
  availablePickupTypes: number[] | null;
  prefix: string | null;
  suffix: string | null;
  dinein: boolean;
  drivethru: boolean;
  takeout: boolean;
  curbside: boolean;
  delivery: boolean;
  isImmediate: boolean;
  asapStartMinutes: number | null;
  asapEndMinutes: number | null;
}
